<template>
  <div class="rightsidebar">
    <div class="container">
      <ul class="sidebar-ul">
        <!-- <li class="li-sy" v-show="!bol">
          <router-link :to="{ name: 'home-sycp' }">
            <img src="/static/img/index/icon_sy.png" />
            <p>试用</p>
          </router-link>
        </li> -->
        <li class="li-kf">
          <a href="javascript:;">
            <img src="/static/img/index/icon_kf.png" />
            <p>客服</p>
          </a>
          <div class="li-tip">
            <div class="title">客服电话</div>
            <ul>
              <li>
                <a
                  href="http://wpa.qq.com/msgrd?v=3&uin=3225009074&site=qq&menu=yes"
                  class="clickus"
                  target="_blank"
                  >点我联系</a
                >
              </li>
              <li>客服电话：0571-89978775</li>
              <li>周一至周五：8:30-17:00</li>
            </ul>
          </div>
        </li>
        <li class="li-wx">
          <a href="javascript:;">
            <img src="/static/img/index/icon_wx.png" />
            <p>关注微信</p>
          </a>
          <div class="li-tip">
            <p>扫码关注“专业家云平台”<br />微信公众号</p>
            <img src="/static/img/index/ewm_zyj.png" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
//	import BackToTop from '@/components/BackToTop'
export default {
  name: "rightSidebar",
  //		components: { BackToTop },
  data() {
    return {
      visible: false,
      scrollTop: "",
      bol: false,
    };
  },
  mounted() {
	//   this.handler()
    //		    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    //		    window.removeEventListener('scroll', this.handleScroll)
    //		    if (this.interval) {
    //		    	clearInterval(this.interval)
    //		    }
  },
  methods: {
    // handler() {
    //   if (this.$route.path === "/product-tpzs") {
    //     this.bol = true;
    //   } else {
    //     this.bol = false;
    //   }
    // },
    //			handleScroll() {
    //		    	this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    //		    	console.log(scrollTop);
    //	        	if(this.scrollTop>500){
    //	            	this.visible=true;
    //	        	}
    //		    },
    //		    backtop() {
    //		    	let timer =null,that=this;
    //		    	cancelAnimationFrame(timer);
    //		    	timer = requestAnimationFrame(function fn(){
    //		    		if(that.scrollTop>0){
    //		    			that.screenTop-=50;
    //		    			document.body.scrollTop = document.documentElement.scrollTop = that.scrollTop;
    //		    			timer = requestAnimationFrame(fn)
    //		    		}else{
    //		    			cancelAnimationFrame(timer);
    //		    			that.visible = false;
    //		    		}
    //		    	});
    //		    }
  },
//   watch: {
//     '$route': 'handler',
//   },
};
</script>

<style scoped="scoped">
.rightsidebar {
  width: 50px;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
}
.rightsidebar .container {
  position: absolute;
  top: 50%;
  width: 50px;
}
.sidebar-ul {
  margin-top: -150px;
}
.sidebar-ul li {
  position: relative;
}
.sidebar-ul li a {
  text-decoration: none;
  color: #fff;
  display: block;
  padding: 20px 10px;
}
.sidebar-ul li a:hover {
  background: #00aaff;
}
.sidebar-ul li .li-tip {
  position: absolute;
  top: -60px;
  right: 50px;
  background: #fff;
  width: 240px;
  text-align: left;
  display: none;
}
.sidebar-ul li:hover .li-tip {
  display: block;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
}
.li-tip .title {
  background: #eee url(/static/img/index/icon_qq.png) no-repeat 20px 12px;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  padding-left: 55px;
}
.li-tip ul {
  padding: 0px 20px;
}
.li-tip ul li {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #ddd;
}
.li-tip ul li .clickus {
  border: 1px solid #ddd;
  color: #333;
  width: 120px;
  text-indent: 45px;
  height: 30px;
  line-height: 30px;
  border-radius: 25px;
  background: url(/static/img/index/icon_chat.png) no-repeat 16px 6px;
  cursor: pointer;
  position: absolute;
  top: 10px;
  padding: 0;
}
.sidebar-ul .li-wx .li-tip {
  text-align: center;
  padding: 20px 0;
}
.topbtn {
  background: url(/static/img/index/top.png) no-repeat center;
  cursor: pointer;
  width: 50px;
  height: 65px;
  border: 0;
  position: absolute;
  left: 0;
  bottom: 0;
}
.topbtn:hover {
  background-color: #00aaff;
}
</style>


// WEBPACK FOOTER //
// src/components/RightSidebar/index.vue